export const ProgressBadge = {
  bindings: {
    number: '<',
    count: '<',
    total: '<',
    size: '@',
  },

  template: `
    <div
      ng-class="$ctrl.size ? 'progress-badge-' + $ctrl.size : ''"
      class="progress-badge">
      <div class="progress-badge-text">
        <small>Week</small>
        <span>{{ $ctrl.number }}</span>
      </div>
      <div
        class="progress-badge-bg theme-bg"
        style="height: {{ $ctrl.percentage }}%">
      </div>
    </div>`,

  controller() {
    'ngInject';

    return {
      $onInit() {
        this.count = 0;
        this.total = 0;
        this.percentage = 0;
      },

      $onChanges(changes) {
        if (this.total > 0) {
          this.percentage = Math.round(this.count / this.total * 100);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Progress/ProgressBadge.js